<!-- 
Search button.

Clicking the button will bring up the search dialog. 
Note that the same search dialog is used for all searches, but it will display differently
depending on the searchFilters that are supplied.
-->
<template>
  <span>
    <v-btn
      :flat="flat"
      :color="color"
      class="ml-2"
      @click="showSearchDialog=true"
    >
      <v-icon class="mr-2">search</v-icon>
      Search
    </v-btn>
    <search-dialog 
      v-model="showSearchDialog" 
      :filters="searchFilters" 
      :criteria="criteria"
      :criteria-mutation="criteriaMutation"
      :title="title"
      :show-all="showAll"
      @click:search="$emit('changed')"
    />
  </span>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import ruleMixins from "@/mixins/rule.mixins";
import SearchDialog from "./SearchDialog.vue";

export default {
  components: { SearchDialog },
  mixins: [lookupMixins, ruleMixins],
  props: {
    criteriaMutation: {
      type: String,
      required: true
    },
    criteria: {
      type: Object,
      required: true
    },
    searchFilters: {
      type: Array,
      required: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSearchDialog: false
    };
  },
  computed: {
    color() {
      return this.flat ? "primary" : "default";
    }
  }
};
</script>
